"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHashSHA256 = void 0;
const js_sha256_1 = require("js-sha256");
const getHashSHA256 = (str) => {
    return (0, js_sha256_1.sha256)(str);
};
exports.getHashSHA256 = getHashSHA256;
